"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _clsx = _interopRequireDefault(require("clsx"));
var _AlertTextModule = _interopRequireDefault(require("./AlertText.module.css"));
var _index = require("../AlertBox/index");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const textColor = {
  error: _index.alertTypes.ERROR,
  success: _index.alertTypes.SUCCESS,
  warning: _index.alertTypes.WARNING,
  info: _index.alertTypes.INFO
};
const AlertText = _ref => {
  let {
    type,
    message
  } = _ref;
  if (message) {
    return /*#__PURE__*/_react.default.createElement("span", {
      className: (0, _clsx.default)(_AlertTextModule.default.errorMsg, _AlertTextModule.default[textColor[type]])
    }, message);
  }
  return null;
};
AlertText.propTypes = {
  message: _propTypes.default.string,
  type: _propTypes.default.oneOf(["error", "success", "warning", "info"])
};
AlertText.defaultProps = {
  type: "error",
  message: undefined
};
var _default = exports.default = AlertText;